import type { BreadcrumbCrumb } from "@/utils/breadcrumbPageTitle"

export const DOCUMENT_TITLE_BRAND = "Tessera"
export const DOCUMENT_TITLE_DASHBOARD = "Dashboard | Tessera"

const DASHBOARD_PATHS = new Set(["/dashboard", "/paywall", "/service-unavailable"])

export function resolveDocumentTitle(
  pathname: string,
  trail: BreadcrumbCrumb[]
): string {
  if (DASHBOARD_PATHS.has(pathname)) {
    return DOCUMENT_TITLE_DASHBOARD
  }

  const pageLabel =
    trail.length > 0 ? trail[trail.length - 1]?.label?.trim() : ""
  if (!pageLabel) {
    return DOCUMENT_TITLE_DASHBOARD
  }

  return `${pageLabel} | ${DOCUMENT_TITLE_BRAND}`
}
